import GuestGuard from '@/auth/main/route-guard/GuestGuard';
import { ClientProvider } from '@/common/application/contexts/ClientContext';
import Loadable from '@/common/presentation/components/utils/Loader/Loadable';
import { Outlet } from 'react-router-dom';
import { lazy } from 'react';

const Login = Loadable(lazy(() => import('@/auth/presentation/pages/Login/Login')));
const Register = Loadable(lazy(() => import('@/auth/presentation/pages/Register/Register')));
const QuickRegister = Loadable(lazy(() => import('@/auth/presentation/pages/QuickRegister/QuickRegister')));
const QuickRegisterSuccess = Loadable(lazy(() => import('@/auth/presentation/pages/QuickRegisterSuccess')));
const RequestRegistration = Loadable(lazy(() => import('@/auth/presentation/pages/RequestRegistration/RequestRegistration')));
const Invite = Loadable(lazy(() => import('@/auth/presentation/pages/Invite')));
const ForgotPassword = Loadable(lazy(() => import('@/auth/presentation/pages/ForgotPassword/ForgotPassword')));
const ForgotUsername = Loadable(lazy(() => import('@/auth/presentation/pages/ForgotUsername/ForgotUsername')));
const ResetPassword = Loadable(lazy(() => import('@/auth/presentation/pages/ResetPassword/ResetPassword')));
const CheckMail = Loadable(lazy(() => import('@/auth/presentation/pages/CheckMail/CheckMail')));
const CodeVerification = Loadable(lazy(() => import('@/auth/presentation/pages/CodeVerification/CodeVerification')));

const AuthRoutes = {
  path: '/',
  element: (
    <GuestGuard>
      <Outlet />
    </GuestGuard>
  ),
  children: [
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/register',
      element: <Register />,
    },
    {
      path: '/invite/:code',
      element: (
        <ClientProvider>
          <Invite />
        </ClientProvider>
      ),
    },
    {
      path: '/quick-register',
      element: <QuickRegister />,
    },
    {
      path: '/quick-register/success',
      element: <QuickRegisterSuccess />,
    },
    {
      path: '/request-registration',
      element: <RequestRegistration />,
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />,
    },
    {
      path: '/forgot-username',
      element: <ForgotUsername />,
    },
    {
      path: '/reset-password/:verificationRequestToken?',
      element: <ResetPassword />,
    },
    {
      path: '/check-mail',
      element: <CheckMail />,
    },
    {
      path: '/code-verification',
      element: <CodeVerification />,
    },

  ],
};

export default AuthRoutes;
